import { IEvent } from "@Interfaces";
import { AiFillMinusCircle } from "@react-icons/all-files/ai/AiFillMinusCircle";
import { ImArrowRight } from "@react-icons/all-files/im/ImArrowRight";
import { AiFillPlusCircle } from "@react-icons/all-files/ai/AiFillPlusCircle";
import { classNames } from "repoV2/utils/common/render/classNames";
import { pluralise } from "@Utils";
import React, { FC, useRef } from "react";
import { isMerchandise } from "@Modules/eventPage/utils/merchandise";
import { Checkbox } from "@mui/material";
import moduleStyle from "./UpsellListingCard.module.scss";
import { IUpsellListings } from "../../IUpsellListings";
import ItemPrice from "../ItemPrice";

const UpsellListingCard: FC<IUpsellListings.IUpsellListing> = ({
    getCheckboxText,
    showListingOriginalPrice,
    item,
    showBlinker,
    toggleOfferingInSelectedUpsellOfferingQuantities:
        toggleOfferingInSelectedUpsellOfferingQuantitiesProp,
    quantity,
    isInSelectedUpsellOfferingQuantities,
    handleQtyChange,
    hasMaxQuantity,
    classes,
    handleCardClick,
    hideItemPrice,
    ...restProps
}) => {
    const buttonEl = useRef<HTMLDivElement>(null);

    const itemQuantity = quantity(item);
    const isItemAddedInOtherListings =
        isInSelectedUpsellOfferingQuantities(item);

    const toggleOfferingInSelectedUpsellOfferingQuantities = (
        upsellListing: IEvent.IUpsellOffering,
        e?: React.MouseEvent
    ): void => {
        if (e && buttonEl.current?.contains(e.target as Node)) return;
        toggleOfferingInSelectedUpsellOfferingQuantitiesProp(upsellListing);
    };

    return (
        <div
            title={item.title}
            className={`${classes?.cardClasses}
                ${moduleStyle.card}
            `}
        >
            <div
                onClick={() => {
                    if (handleCardClick) handleCardClick(item);
                }}
                className={moduleStyle.body}
            >
                <div className={moduleStyle.title}>{item.title}</div>
                <div
                    className={`${moduleStyle.description} mt-2`}
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{ __html: item.description }}
                />
                {!hideItemPrice(item) && (
                    <div className="d-flex mt-2">
                        <span className={`${moduleStyle.upsellPrice} mr-1`}>
                            <ItemPrice item={item} {...restProps} />
                        </span>
                        &nbsp;
                        {showListingOriginalPrice(item) && (
                            <span className={`${moduleStyle.lineThroughPrice}`}>
                                {item.currency}
                                {item.price_per_head}
                            </span>
                        )}
                    </div>
                )}
            </div>

            <div
                onClick={e => {
                    e.preventDefault();
                    toggleOfferingInSelectedUpsellOfferingQuantities(item, e);
                }}
                className={`${moduleStyle.paymentStrip} d-flex p-1 justify-content-center align-items-center`}
            >
                {isMerchandise(item) && isItemAddedInOtherListings ? (
                    <div
                        className={classNames(
                            moduleStyle.buttonContainer,
                            moduleStyle.quantityControl
                        )}
                        role="button"
                        ref={buttonEl}
                    >
                        <AiFillMinusCircle
                            size="24px"
                            onClick={() => handleQtyChange(item, false)}
                        />

                        <span className={`mx-1 ${moduleStyle.qunatity}`}>
                            {itemQuantity}
                            &nbsp;
                            {pluralise("item", itemQuantity)}
                        </span>
                        <AiFillPlusCircle
                            size="24px"
                            onClick={() =>
                                hasMaxQuantity(item)
                                    ? null
                                    : handleQtyChange(item, true)
                            }
                        />
                    </div>
                ) : (
                    <div className="d-flex align-items-center">
                        {!isItemAddedInOtherListings && showBlinker && (
                            <ImArrowRight
                                className={`${moduleStyle.arrowGif}`}
                            />
                        )}
                        <Checkbox
                            classes={{
                                checked: `${moduleStyle.checkbox_checked}`,
                            }}
                            checked={isItemAddedInOtherListings}
                            size="small"
                            color="primary"
                            className={`${moduleStyle.checkbox} mr-1`}
                        />
                        <div className={`${moduleStyle.checkboxText}`}>
                            {getCheckboxText(item)}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default UpsellListingCard;
